import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'
import { StationCell } from './components/station-cell'
import styles from './StationRow.module.scss'
import { useStations } from 'components/common/hooks/useStations'

const cx = classNames.bind(styles)

const StationRow = ({
  children,
  stationId,
  cashCreditPricing,
  brand,
  name,
  error,
}) => {
  const { stations } = useStations()

  const station = stations.find((s) => s.id === stationId)

  const supportsPriceExecution = station?.supportsPriceExecution
  const posProviderKey = station?.posProviderKey

  return (
    <div
      key={stationId}
      className={cx('station-row', { 'no-cc': !cashCreditPricing })}
    >
      <StationCell brand={brand} name={name} error={error} supportsPriceExecution={supportsPriceExecution} posProviderKey={posProviderKey} />
      {children}
    </div>
  )
}

StationRow.propTypes = {
  children: PropTypes.shape().isRequired,
  stationId: PropTypes.string.isRequired,
  cashCreditPricing: PropTypes.bool.isRequired,
  brand: PropTypes.shape(),
  name: PropTypes.string.isRequired,
  error: PropTypes.bool,
}

StationRow.defaultProps = {
  error: false,
}

export { StationRow }
